// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const portAuth = '9888';
export const portGescom = '9888';
export const port = '9091';
export const host = 'localhost';
// export const host = '192.168.1.137';
// export const host = '192.168.1.235';
export const protocol = 'http://';
export const station = 'local';
export const modules = 'mobilite';

const HOST = 'localhost';
// const HOST = '192.168.1.192';
// const HOST = '192.168.1.101';
const PORT = '9888';
const PROTOCOL = 'http://';
const STATION = 'local';
const MODULE = 'mobilite';
// const MODULE = 'gescom';

// Configuration des services
const SERVICES = {
  admin: '4050',
  gescom: '4400',
  compta: '4300',
  paie: '9091',
  societe: '4100',
  mobile: '4000',
  pos: '4230'
};

// Exportation de l'environnement
export const environment = {
  // Mode d'exécution
  production: true,
  tenantID: 'tenantMaster', // 'eric123456', // 'romuald', //'tenantMaster', // 'cowee'
  startMode: 'dev', // Mode de démarrage [dev, prod, cloud]

  // Informations générales sur l'application
  appTitle: 'Aurore ERP',
  station: STATION,
  protocol: PROTOCOL,
  host: HOST,
  port: PORT,
  module: MODULE,

  // Logos de l'application
  logos: {
    app: '../assets/images/default/aurore_Commande.png',
    login: '../assets/images/default/logo_main_icon_only.png',
    favicon: '../assets/images/default/favicon.ico'
  },

  // Configuration des URLs de l'API
  api: {
    base: `${PROTOCOL}${HOST}:${PORT}/api/${STATION}/gescom/v1`,
    auth: `${PROTOCOL}${HOST}:${PORT}/api/${STATION}/auth/v1`,
    report: `${PROTOCOL}${HOST}:${PORT}/api/${STATION}/etat/v1`,
    hospital: `${PROTOCOL}${HOST}:${PORT}/api/${STATION}/hospital/v1`,
    delete: `${PROTOCOL}${HOST}:${PORT}/api/${STATION}/v1`,
    gescom_v2: `${PROTOCOL}${HOST}:${PORT}/api/${STATION}/gescom/v2`,
    gescom_v3: `${PROTOCOL}${HOST}:${PORT}/api/${STATION}/gescom/v3`,
    config: `${PROTOCOL}${HOST}:${PORT}/api/${STATION}/gescom/config`,
    base_api: `${PROTOCOL}${HOST}:${PORT}/api/${STATION}/gescom`,
    base_gc: `${PROTOCOL}${HOST}:${PORT}/api/${STATION}/v1`
  },

  // Paramètre de pagination par défaut
  defaultListSize: 20, // Nombre d'éléments affichés par défaut dans une liste

  // URLs des différents modules de l'application
  services: {
    admin: `${PROTOCOL}${HOST}:${SERVICES.admin}`,
    gescom: `${PROTOCOL}${HOST}:${SERVICES.gescom}`,
    compta: `${PROTOCOL}${HOST}:${SERVICES.compta}`,
    paie: `${PROTOCOL}${HOST}:${SERVICES.paie}`,
    societe: `${PROTOCOL}${HOST}:${SERVICES.societe}`,
    mobile: `${PROTOCOL}${HOST}:${SERVICES.mobile}`,
    pos: `${PROTOCOL}${HOST}:${SERVICES.pos}`
  },

  // URLs spécifiques aux entités et aux rapports
  entityUrls: {
    gescom: '/common/find/entity',
    essentialData: '/common/find/essential/data',
    essentialDataPage: '/common/page/find/essential/data',
  },
  reportUrls: {
    common: '/report/generate',
  },

  baseUrlLicense: 'http://localhost:4094/'
};



